import { render, staticRenderFns } from "./WhoPays.vue?vue&type=template&id=32d79bb6&"
import script from "./WhoPays.vue?vue&type=script&lang=js&"
export * from "./WhoPays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports